import { React, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  RightLayoutContainer,
  TableLayoutData,
  PageTitleComp,
} from "../../styledElements";
import { Button, PageHeader, Table, Tooltip, Progress, Tabs, Checkbox } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import { Styled, StyledTab } from "../../pageStyled";
import moment from "moment";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import ParentRollView from "../../../Assets/Icons/tissue-roll-view.svg";
import OrderAndStockDetails from "./ProductionDetailsDrawers/viewOrderAndStockDetailsDrawer";
import MultiStageParentSetDrawer from "./ProductionDetailsDrawers/viewCombinationDetailsDrawer";
import {
  getFilteredProductionDetails,
  getProductionDetails,
  searchProductionDetails,
  getMultistageProductionDetails,
  getMultistageAllProductionDetails,
  searchMultistageFilteredProductionDetails
} from "../../../Services/productionPlanningServices";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import {
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import { toHandlePOName } from "../../../Utils/helper/helper";


function getYesterdaysDate() {
  const today = new Date();
  const yesterday = new Date(today);
  
  // Subtract one day (24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
  yesterday.setDate(today.getDate() - 1);

  const year = yesterday.getFullYear();
  const month = String(yesterday.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(yesterday.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

const Panes = Tabs.TabPane;

const ProductionDetails = (props) => {
    const navigate = useNavigate();
    const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
    const [userDetails, setUserDetails] = useState(JSON.parse(localStorage.getItem("user-details")));
    const [searchValue, setSearchValue] = useState("");
    const [currentTab, setCurrentTab] = useState("1");
    const [rendering, setRendering] = useState(true);
    const [clearSearch, setClearSearch] = useState(false);
    const [emptyStateLabel, setEmptyStateLabel] = useState();
    const [emptyStatePropsData, setEmptyStatePropsData] = useState();
    const [todaysRecordLoading, setTodaysRecordLoading] = useState(true);
    const [yesterdaysRecordLoading, setYesterdaysRecordLoading] = useState(true);
    const [allRecordLoading, setAllRecordLoading] = useState(true);
    const [todaysRecord, setTodaysRecord] = useState([]);
    const [yesterdaysRecord, setYesterdaysRecord] = useState([]);
    const [allRecord, setAllRecord] = useState([]);
    const [appliedFilters, setAppliedFilters] = useState([]);
    const [totalTodaysRecord, setTotalTodaysRecords] = useState();
    const [totalYesterdaysRecord, setTotalYesterdaysRecord] = useState();
    const [totalAllRecord, setTotalAllRecord] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [currentOrderId, setCurrentOrderId] = useState();
    const [orderSideDrawer, setOrderGradeSideDrawer] = useState(false);
    const [parentSideDrawer, setParentSideDrawer] = useState(false);
    const [selectedParentReel, setSelectedParentReel] = useState();
    const [isProduced, setIsProduced] = useState(false);
    const [jobcardType, setJobcardType] = useState();
    const [recordType, setRecordType] = useState();
    const [orderType, setOrderType] = useState();
    const [selectedReelType, setSelectedReelType] = useState('both');
    const selectedReelTypeRef = useRef('both');
    const [filterTags, setFilterTags] = useState([]);
    const [allData, setAllData] = useState([]);
    const [totalCount, setTotalCount] = useState();
    const [tableParams, setTableParams] = useState({
        sort_by: "closing_date",
        sort_type: "descending",
        page: 1,
        size: 10,
    });
    const paginationRefForAllTableParams = useRef({
        sort_by: "closing_date",
        sort_type: "descending",
        page: 1,
        size: 10
    });

    const todaysColumnsHead = useRef([
      {
        title: "",
        dataIndex: "icons",
        width: "2%",
        align: "center",
        fixed: "left",
        render: (text, record, index) => (
          <div className="actionBtn">
            <Styled>
              <Tooltip
                placement="topRight"
                title={
                  record.type == "finished" || record.type == "intermediate"
                    ? capitalize(record.type) + " Reels"
                    : "Sheet set"
                }
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button style={{ cursor: "default" }}>
                  <Iconmoon
                    icon={
                      record.type == "finished" || record.type == "intermediate"
                        ? "tissue-role"
                        : "sheet"
                    }
                    size={
                      record.type == "finished" || record.type == "intermediate"
                        ? 16
                        : 18
                    }
                    color={
                      record.type == "intermediate" ? "#605E5C" : "#EA655B"
                    }
                  />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      },
      {
        title: "Reel/Set No.  ",
        dataIndex: "reelNo",
        width: "5%",
        align: "center",
        fixed: "left",
      },
      {
        title: "Mill Item No.",
        dataIndex: "mill_item_no",
        width: "5%",
        align: "center",
        fixed: "left",
      },
      {
        title: "Size(W * L)",
        dataIndex: "size",
        width: "5%",
        align: "center",
      },
      {
        title: "Order/Stock No.",
        dataIndex: "order_stock_no",
        width: "7%",
        align: "center",
        render: (text, record) => (
          <div className="actionBtn2">
            <Button
                style={{ background: "transparent" }}
                className="textTypeBtn textBtnIcon"
                onClick={() => openOrderDrawer(record)}
            > {text}
            </Button>
            {record.reel_type == "stock" && 
              <div>
                  <span
                    style={{
                      color: "rgb(234, 101, 91)",
                      fontStyle: "italic",
                      fontSize: "10px",
                    }}
                  >
                    Stock
                  </span>
              </div>}
            </div>
        )
      },
      {
        title: "PO No.",
        dataIndex: "po_no",
        width: "8%",
        align: "center",
        render: (text, record) => (
          toHandlePOName(text)
        )
      },
      {
        title: "Produced Spec",
        dataIndex: "product_spec",
        width: "5%",
        align: "center",
      },
      {
        title: "Produced Quantity",
        dataIndex: "produced_qty",
        width: "5%",
        align: "center",
      },
      {
        title: "Actual Produced Quantity",
        dataIndex: "physical_qty",
        width: "5%",
        align: "center",
      },
      {
        title: "Accepted Quantity",
        dataIndex: "accepted_qty",
        width: "5%",
        align: "center",
      },
      {
        title: "Rejected Quantity",
        dataIndex: "rejected_qty",
        width: "5%",
        align: "center",
      },
      {
        title: "Rejection Remarks",
        dataIndex: "remarks",
        width: "9%",
        align: "center",
        render: (text, record) => (
          <div>
            {(record.remarks && record.remarks != "" && record.remarks != null) ? 
            (<div>
              {(record?.remarks?.length < 33) ? (
                <Tooltip title={record.remarks}>
                <h1>{record.remarks}</h1>
                </Tooltip>
              ) : (
                <Tooltip title={record.remarks}>
                <h1>{record?.remarks?.slice(0,34)+"..."}</h1>
                </Tooltip>
              )
              }
            </div>) : (null)}
          </div>
        ),
      },
      {
        title: "Job Card No.",
        dataIndex: "jc_code",
        width: "8%",
        align: "center",
      },
      {
        title: "Combination No.",
        dataIndex: "combination_no",
        width: "6%",
        align: "center",
      },
      {
        title: "Parent Set",
        dataIndex: "parent_set",
        width: "5%",
        align: "center",
        render: (text, record) => (
            <div className="actionBtn2">
                <Button
                style={{ background: "transparent" }}
                className="textTypeBtn textBtnIcon"
                onClick={() => openComboDetailsDrawer(record)}
            >
                {`${text}`}
            </Button>
            </div>
        )
      },
      {
        title: "Finishing Date",
        dataIndex: "finishing_date",
        width: "7%",
        align: "center",
        sorter: {
          compare: (a, b) =>
            new Date(a.finishing_date) - new Date(b.finishing_date),
        },
      },
      {
        title: "Finishing Shift",
        dataIndex: "finishing_shift",
        width: "4.7%",
        align: "center",
      },
      {
        title: "Expected Dispatch Date",
        dataIndex: "dispatch_date",
        width: "9.5%",
        align: "center",
        sorter: {
          compare: (a, b) =>
            new Date(a.dispatch_date) - new Date(b.dispatch_date),
        },
      },
      {
        title: "Order Delivery Date",
        dataIndex: "delivery_date",
        width: "8.3%",
        align: "center",
        sorter: {
          compare: (a, b) =>
            new Date(a.delivery_date) - new Date(b.delivery_date),
        },
      },
      {
        title: "Closing Date",
        dataIndex: "closing_date",
        width: "6%",
        align: "center",
        sorter: {
          compare: (a, b) =>
            new Date(a.closing_date) - new Date(b.closing_date),
        },
      },
      {
        title: "Priority",
        dataIndex: "priority",
        width: "5%",
        align: "center",
        render: (text, record) => (
          <div className="actionBtn">
            <Button style={{ cursor: "default" }}>
              <Iconmoon
                icon={record.priority ? "correct" : "wrong"}
                size={16}
                color={record.priority ? "#3FBD61" : "#a19f9d"}
              />
            </Button>
          </div>
        ),
      },
      {
        title: "Actions",
        dataIndex: "actions",
        width: "6%",
        align: "center",
        render: (text, record) => (
          <div className="actionBtn">
            {record.type !== "intermediate" ? (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"View details of this order"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button
                    onClick={() => openOrderDrawer(record)}
                    disabled={!userDetails.roles.production.prod_details.view}
                  >
                    <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                  </Button>
                </Tooltip>
              </Styled>
            ) : (
                <div style={{ display: "flex" }}>
                <div style={{ width: "38px" }}></div>
              </div>
            )}
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View Combination Details"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => openComboDetailsDrawer(record)}
                  disabled={!userDetails.roles.production.prod_details.view}
                >
                  <img style={{ width: "20px" }} src={ParentRollView} />
                </Button>
              </Tooltip>
            </Styled>
          </div>
        ),
      },
    ]);

    const yesterdaysColumnsHead = useRef([
        {
            title: "",
            dataIndex: "icons",
            width: "2%",
            align: "center",
            fixed: "left",
            render: (text, record, index) => 
             ( 
                <div className="actionBtn">
                    <Styled>
                        <Tooltip
                            placement="topRight"
                            title={(record.type == "finished" || record.type == "intermediate") ? (capitalize(record.type) +" Reels") : "Sheet set"}
                            className="edit-tooltip"
                            getPopupContainer={(triggerNode) => triggerNode}
                        >
                            <Button style={{ cursor: "default" }}>
                                <Iconmoon icon={(record.type == "finished" || record.type == "intermediate") ? "tissue-role" : "sheet"} size={(record.type == "finished" || record.type == "intermediate") ? 16 : 18} color={ record.type == "intermediate" ? "#605E5C" : "#EA655B"} />
                            </Button>
                        </Tooltip>
                    </Styled>
                </div>
            )
          },
          {
            title: "Reel/Set No.  ",
            dataIndex: "reelNo",
            width: "5%",
            align: "center",
            fixed: "left",
            // render: (text, record) => (
            //   <div className="">
            //     <Button
            //       style={{ background: "transparent" }}
            //       className="textTypeBtn textBtnIcon"
            //       onClick={() => openParentReelDrawer(record)}
            //     >
            //       {`#${record.parent_reel}`}
            //     </Button>
            //   </div>
            // ),
          },
          {
            title: "Mill Item No.",
            dataIndex: "mill_item_no",
            width: "5%",
            align: "center",
            fixed: "left",
          },
          {
            title: "Size(W * L)",
            dataIndex: "size",
            width: "5%",
            align: "center",
          },
          {
            title: "Order/Stock No.",
            dataIndex: "order_stock_no",
            width: "7%",
            align: "center",
            render: (text, record) => (
              <div className="actionBtn2">
                <Button
                    style={{ background: "transparent" }}
                    className="textTypeBtn textBtnIcon"
                    onClick={() => openOrderDrawer(record)}
                > {text}
                </Button>
                {record.reel_type == "stock" && 
                  <div>
                      <span
                        style={{
                          color: "rgb(234, 101, 91)",
                          fontStyle: "italic",
                          fontSize: "10px",
                        }}
                      >
                        Stock
                      </span>
                  </div>}
                </div>
            )
          },
          {
            title: "PO No.",
            dataIndex: "po_no",
            width: "8%",
            align: "center",
            render: (text, record) => (
          toHandlePOName(text)
        )
          },
          {
            title: "Produced Spec",
            dataIndex: "product_spec",
            width: "5%",
            align: "center",
          },
          {
            title: "Produced Quantity",
            dataIndex: "produced_qty",
            width: "5%",
            align: "center",
          },
          {
            title: "Actual Produced Quantity",
            dataIndex: "physical_qty",
            width: "5%",
            align: "center",
          },
          {
            title: "Accepted Quantity",
            dataIndex: "accepted_qty",
            width: "5%",
            align: "center",
          },
          {
            title: "Rejected Quantity",
            dataIndex: "rejected_qty",
            width: "5%",
            align: "center",
          },
          {
            title: "Rejection Remarks",
            dataIndex: "remarks",
            width: "9%",
            align: "center",
            render: (text, record) => (
              <div>
                {(record.remarks && record.remarks != "" && record.remarks != null) ? 
                (<div>
                  {(record?.remarks?.length < 33) ? (
                    <Tooltip title={record.remarks}>
                    <h1>{record.remarks}</h1>
                    </Tooltip>
                  ) : (
                    <Tooltip title={record.remarks}>
                    <h1>{record?.remarks?.slice(0,34)+"..."}</h1>
                    </Tooltip>
                  )
                  }
                </div>) : (null)}
              </div>
            ),
          },
          {
            title: "Job Card No.",
            dataIndex: "jc_code",
            width: "8%",
            align: "center",
          },
          {
            title: "Combination No.",
            dataIndex: "combination_no",
            width: "6%",
            align: "center",
          },
          {
            title: "Parent Set",
            dataIndex: "parent_set",
            width: "5%",
            align: "center",
            render: (text, record) => (
                <div className="actionBtn2">
                    <Button
                    style={{ background: "transparent" }}
                    className="textTypeBtn textBtnIcon"
                    onClick={() => openComboDetailsDrawer(record)}
                >
                    {`${text}`}
                </Button>
                </div>
            )
          },
          {
            title: "Finishing Date",
            dataIndex: "finishing_date",
            width: "7%",
            align: "center",
            sorter: {
              compare: (a, b) =>
                new Date(a.finishing_date) - new Date(b.finishing_date),
            },
          },
          {
            title: "Finishing Shift",
            dataIndex: "finishing_shift",
            width: "4.7%",
            align: "center",
          },
          {
            title: "Expected Dispatch Date",
            dataIndex: "dispatch_date",
            width: "9.5%",
            align: "center",
            sorter: {
              compare: (a, b) =>
                new Date(a.dispatch_date) - new Date(b.dispatch_date),
            },
          },
          {
            title: "Order Delivery Date",
            dataIndex: "delivery_date",
            width: "8.3%",
            align: "center",
            sorter: {
              compare: (a, b) =>
                new Date(a.delivery_date) - new Date(b.delivery_date),
            },
          },
          {
            title: "Closing Date",
            dataIndex: "closing_date",
            width: "6%",
            align: "center",
            sorter: {
              compare: (a, b) =>
                new Date(a.closing_date) - new Date(b.closing_date),
            },
          },
          {
            title: "Priority",
            dataIndex: "priority",
            width: "5%",
            align: "center",
            render: (text, record) =>
            (
              <div className="actionBtn">
                <Button style={{ cursor: "default" }}>
                  <Iconmoon
                    icon={record.priority ? "correct" : "wrong"}
                    size={16}
                    color={record.priority ? "#3FBD61" : "#a19f9d"}
                  />
                </Button>
              </div>
            )
          },
          {
            title: "Actions",
            dataIndex: "actions",
            width: "6%",
            align: "center",
            render: (text, record) => (
              <div className="actionBtn">
                {record.type !== "intermediate" ? (
                  <Styled>
                    <Tooltip
                      placement="bottomRight"
                      title={"View details of this order"}
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      <Button
                        onClick={() => openOrderDrawer(record)}
                        disabled={!userDetails.roles.production.prod_details.view}
                      >
                        <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                      </Button>
                    </Tooltip>
                  </Styled>
                ) : (
                    <div style={{ display: "flex" }}>
                    <div style={{ width: "38px" }}></div>
                  </div>
                )}
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Combination Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => openComboDetailsDrawer(record)}
                      disabled={!userDetails.roles.production.prod_details.view}
                    >
                      <img style={{ width: "20px" }} src={ParentRollView} />
                    </Button>
                  </Tooltip>
                </Styled>
              </div>
            ),
          },
    ]);

    const allRecordsColumnsHead = useRef([
        {
            title: "",
            dataIndex: "icons",
            width: "2%",
            align: "center",
            fixed: "left",
            render: (text, record, index) => 
             ( 
                <div className="actionBtn">
                    <Styled>
                        <Tooltip
                            placement="topRight"
                            title={(record.type == "finished" || record.type == "intermediate") ? (capitalize(record.type) +" Reels") : "Sheet set"}
                            className="edit-tooltip"
                            getPopupContainer={(triggerNode) => triggerNode}
                        >
                            <Button style={{ cursor: "default" }}>
                                <Iconmoon icon={(record.type == "finished" || record.type == "intermediate") ? "tissue-role" : "sheet"} size={(record.type == "finished" || record.type == "intermediate") ? 16 : 18} color={ record.type == "intermediate" ? "#605E5C" : "#EA655B"} />
                            </Button>
                        </Tooltip>
                    </Styled>
                </div>
            )
          },
          {
            title: "Reel/Set No.  ",
            dataIndex: "reelNo",
            width: "5%",
            align: "center",
            fixed: "left",
            // render: (text, record) => (
            //   <div className="">
            //     <Button
            //       style={{ background: "transparent" }}
            //       className="textTypeBtn textBtnIcon"
            //       onClick={() => openParentReelDrawer(record)}
            //     >
            //       {`#${record.parent_reel}`}
            //     </Button>
            //   </div>
            // ),
          },
          {
            title: "Mill Item No.",
            dataIndex: "mill_item_no",
            width: "5%",
            align: "center",
            fixed: "left",
          },
          {
            title: "Size(W * L)",
            dataIndex: "size",
            width: "5%",
            align: "center",
          },
          {
            title: "Order/Stock No.",
            dataIndex: "order_stock_no",
            width: "7%",
            align: "center",
            render: (text, record) => (
              <div className="actionBtn2">
                <Button
                    style={{ background: "transparent" }}
                    className="textTypeBtn textBtnIcon"
                    onClick={() => openOrderDrawer(record)}
                > {text}
                </Button>
                {record.reel_type == "stock" && 
                  <div>
                      <span
                        style={{
                          color: "rgb(234, 101, 91)",
                          fontStyle: "italic",
                          fontSize: "10px",
                        }}
                      >
                        Stock
                      </span>
                  </div>}
                </div>
            )
          },
          {
            title: "PO No.",
            dataIndex: "po_no",
            width: "8%",
            align: "center",
            render: (text, record) => (
          toHandlePOName(text)
        )
          },
          {
            title: "Produced Spec",
            dataIndex: "product_spec",
            width: "5%",
            align: "center",
          },
          {
            title: "Produced Quantity",
            dataIndex: "produced_qty",
            width: "5%",
            align: "center",
          },
          {
            title: "Actual Produced Quantity",
            dataIndex: "physical_qty",
            width: "5%",
            align: "center",
          },
          {
            title: "Accepted Quantity",
            dataIndex: "accepted_qty",
            width: "5%",
            align: "center",
          },
          {
            title: "Rejected Quantity",
            dataIndex: "rejected_qty",
            width: "5%",
            align: "center",
          },
          {
            title: "Rejection Remarks",
            dataIndex: "remarks",
            width: "9%",
            align: "center",
            render: (text, record) => (
              <div>
                {(record.remarks && record.remarks != "" && record.remarks != null) ? 
                (<div>
                  {(record?.remarks?.length < 33) ? (
                    <Tooltip title={record.remarks}>
                    <h1>{record.remarks}</h1>
                    </Tooltip>
                  ) : (
                    <Tooltip title={record.remarks}>
                    <h1>{record?.remarks?.slice(0,34)+"..."}</h1>
                    </Tooltip>
                  )
                  }
                </div>) : (null)}
              </div>
            ),
          },
          {
            title: "Job Card No.",
            dataIndex: "jc_code",
            width: "8%",
            align: "center",
          },
          {
            title: "Combination No.",
            dataIndex: "combination_no",
            width: "6%",
            align: "center",
          },
          {
            title: "Parent Set",
            dataIndex: "parent_set",
            width: "5%",
            align: "center",
            render: (text, record) => (
                <div className="actionBtn2">
                    <Button
                    style={{ background: "transparent" }}
                    className="textTypeBtn textBtnIcon"
                    onClick={() => openComboDetailsDrawer(record)}
                >
                    {`${text}`}
                </Button>
                </div>
            )
          },
          {
            title: "Finishing Date",
            dataIndex: "finishing_date",
            width: "7%",
            align: "center",
            sorter: {
              compare: (a, b) =>
                new Date(a.finishing_date) - new Date(b.finishing_date),
            },
          },
          {
            title: "Finishing Shift",
            dataIndex: "finishing_shift",
            width: "4.7%",
            align: "center",
          },
          {
            title: "Expected Dispatch Date",
            dataIndex: "dispatch_date",
            width: "9.5%",
            align: "center",
            sorter: {
              compare: (a, b) =>
                new Date(a.dispatch_date) - new Date(b.dispatch_date),
            },
          },
          {
            title: "Order Delivery Date",
            dataIndex: "delivery_date",
            width: "8.3%",
            align: "center",
            sorter: {
              compare: (a, b) =>
                new Date(a.delivery_date) - new Date(b.delivery_date),
            },
          },
          {
            title: "Closing Date",
            dataIndex: "closing_date",
            width: "6%",
            align: "center",
            sorter: {
              compare: (a, b) =>
                new Date(a.closing_date) - new Date(b.closing_date),
            },
          },
          {
            title: "Priority",
            dataIndex: "priority",
            width: "5%",
            align: "center",
            render: (text, record) =>
            (
              <div className="actionBtn">
                <Button style={{ cursor: "default" }}>
                  <Iconmoon
                    icon={record.priority ? "correct" : "wrong"}
                    size={16}
                    color={record.priority ? "#3FBD61" : "#a19f9d"}
                  />
                </Button>
              </div>
            )
          },
          {
            title: "Actions",
            dataIndex: "actions",
            width: "6%",
            align: "center",
            render: (text, record) => (
              <div className="actionBtn">
                {record.type !== "intermediate" ? (
                  <Styled>
                    <Tooltip
                      placement="bottomRight"
                      title={"View details of this order"}
                      className="edit-tooltip"
                      getPopupContainer={(triggerNode) => triggerNode}
                    >
                      <Button
                        onClick={() => openOrderDrawer(record)}
                        disabled={!userDetails.roles.production.prod_details.view}
                      >
                        <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                      </Button>
                    </Tooltip>
                  </Styled>
                ) : (
                    <div style={{ display: "flex" }}>
                    <div style={{ width: "38px" }}></div>
                  </div>
                )}
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Combination Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => openComboDetailsDrawer(record)}
                      disabled={!userDetails.roles.production.prod_details.view}
                    >
                      <img style={{ width: "20px" }} src={ParentRollView} />
                    </Button>
                  </Tooltip>
                </Styled>
              </div>
            ),
          },
    ]);

    const refresh = () => {
      setTodaysRecordLoading(true);
      setYesterdaysRecordLoading(true);
      setAllRecordLoading(true);
      setTodaysRecord([]);
      setYesterdaysRecord([]);
      setAllRecord([]);
      setSearchValue("");
      setClearSearch(true);
      setRendering(true);
    };

    const openOrderDrawer = (record) => {
        setCurrentOrderId(record.order_stock_no);
        setOrderGradeSideDrawer(true);
        setJobcardType(record.jobcard_type);
        setRecordType(record.type);
        setOrderType(record.reel_type);
    };

    const openComboDetailsDrawer = (record) => {
      setSelectedParentReel(record.parent_set);
      setJobcardType(record.jobcard_type);
      setParentSideDrawer(true);
      setRecordType(record.type);
      setIsProduced(record.status === 'produced' || record.status === "rejected");
    };

    const closeComboDetailsDrawer = () => {
        setSelectedParentReel();
        setParentSideDrawer(false);
        setIsProduced(false);
        setJobcardType();
        setRecordType();
    };

    const closeOrderDrawer = () => {
        setOrderGradeSideDrawer(false);
        setJobcardType();
        setRecordType();        
        setOrderType();
    };

    const onTodayChange = (pagination, filters, sorter, extra, orderState) => {
      setTodaysRecord([]);
        setTodaysRecordLoading(true);
        todaysColumnsHead.current?.map((item) => {
          if (item.dataIndex !== sorter?.field) {
            item["sortOrder"] = null;
          }
          if (item.dataIndex == sorter?.field) {
            item["sortOrder"] = sorter ? sorter.order : "";
          }
        });
        const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
        if (
          sorter.field &&
          (paginationRefForAllTableParams.current.sort_type !== tempSort ||
            paginationRefForAllTableParams.current.sort_by !== sorter.field)
        ) {
          setClearSearch(true);
          setCurrentPage(1);
          setTableParams({
            ...tableParams,
            page: 1,
            size: pagination.pageSize,
            sort_by: sorter.field,
            sort_type: tempSort,
          });
          paginationRefForAllTableParams.current = {
            ...tableParams,
            page: 1,
            size: pagination.pageSize,
            sort_by: sorter.field,
            sort_type: tempSort,
          };
        } else {
            setCurrentPage(pagination.current);
            setTableParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            sort_by: sorter.field || "closing_date",
            sort_type: tempSort,
          });
          paginationRefForAllTableParams.current = {
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            sort_by: sorter.field || "closing_date",
            sort_type: tempSort,
          };
        }
        setRendering(true);
    };

    const onYestChange = (pagination, filters, sorter, extra, orderState) => {
      setYesterdaysRecord([]);
        setYesterdaysRecordLoading(true);
        yesterdaysColumnsHead.current?.map((item) => {
          if (item.dataIndex !== sorter?.field) {
            item["sortOrder"] = null;
          }
          if (item.dataIndex == sorter?.field) {
            item["sortOrder"] = sorter ? sorter.order : "";
          }
        });
        const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
        if (
          sorter.field &&
          (paginationRefForAllTableParams.current.sort_type !== tempSort ||
            paginationRefForAllTableParams.current.sort_by !== sorter.field)
        ) {
          setClearSearch(true);
          setCurrentPage(1);
          setTableParams({
            ...tableParams,
            page: 1,
            size: pagination.pageSize,
            sort_by: sorter.field,
            sort_type: tempSort,
          });
          paginationRefForAllTableParams.current = {
            ...tableParams,
            page: 1,
            size: pagination.pageSize,
            sort_by: sorter.field,
            sort_type: tempSort,
          };
        } else {
            setCurrentPage(pagination.current);
            setTableParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            sort_by: sorter.field || "closing_date",
            sort_type: tempSort,
          });
          paginationRefForAllTableParams.current = {
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            sort_by: sorter.field || "closing_date",
            sort_type: tempSort,
          };
        }
        setRendering(true);
    };

    const onChange = (pagination, filters, sorter, extra, orderState) => {
      setAllRecord([]);
      setAllRecordLoading(true);
      allRecordsColumnsHead.current?.map((item) => {
        if (item.dataIndex !== sorter?.field) {
          item["sortOrder"] = null;
        }
        if (item.dataIndex == sorter?.field) {
          item["sortOrder"] = sorter ? sorter.order : "";
        }
      });
      const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
      if (
        sorter.field &&
        (paginationRefForAllTableParams.current.sort_type !== tempSort ||
        paginationRefForAllTableParams.current.sort_by !== sorter.field)
      ) {
        setClearSearch(true);
        setCurrentPage(1);
        setTableParams({
          ...tableParams,
          page: 1,
          size: pagination.pageSize,
          sort_by: sorter.field,
          sort_type: tempSort,
        });
        paginationRefForAllTableParams.current = {
          ...tableParams,
          page: 1,
          size: pagination.pageSize,
          sort_by: sorter.field,
          sort_type: tempSort,
        };
      } else {
        setCurrentPage(pagination.current);
        setTableParams({
          ...tableParams,
          page: pagination.current,
          size: pagination.pageSize,
          sort_by: sorter.field || "closing_date",
          sort_type: tempSort,
        });
        paginationRefForAllTableParams.current = {
          ...tableParams,
          page: pagination.current,
          size: pagination.pageSize,
          sort_by: sorter.field || "closing_date",
          sort_type: tempSort,
        };
      }
      setRendering(true);
    };

    const handleTabChange = (key) => {
      setTodaysRecord([]);
      setYesterdaysRecord([]);
      setAllRecord([]);
      todaysColumnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
      yesterdaysColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
      });
      allRecordsColumnsHead.current?.map((item) => {
        item["sortOrder"] = null;
      });
        setClearSearch(true);
        setCurrentPage(1);
        setTableParams({
        sort_by: "closing_date",
        sort_type: "descending",
        page: 1,
        size: 10,
        });
        paginationRefForAllTableParams.current = {
        sort_by: "closing_date",
        sort_type: "descending",
        page: 1,
        size: 10,
        };

        setSearchValue("");
        setClearSearch(true);
        setCurrentTab(key);
        setRendering(true);
    };

    const fetchTodaysRecordDetails = (params) => {
      let todaysDate = new Date();
      let month = "" + (todaysDate.getMonth() + 1);
      let day = "" + todaysDate.getDate();
      let year = todaysDate.getFullYear();
      let startEndDate = year + "-" + month + "-" + day;
      let filterData = [
        {
          type: "closing_date",
          "start_date": startEndDate,
          "end_date": startEndDate,
          // start_date: "2024-01-31",
          // end_date: "2024-01-31",
        },
        {
          type: "reel_type",
          reel_type: selectedReelTypeRef.current
        },
      ];
      getMultistageProductionDetails(filterData, params)
        .then((resp) => {
          if (!resp.data.data.reels.length) {
            setEmptyStateLabel("noData");
          }
          setTotalCount(resp.data.data.total_reels);
        //   console.log(resp.data.data.reels);
          const list = resp.data.data.reels.map((reel) => {
            let sizeKey;
            let po_value;
            let deliveryDate;
            let order_stock;
            let formattedCode = getJCCode(reel.jobcard_code);
            if(reel.type == "intermediate"){
                sizeKey = reel?.reel_size ? (reel?.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase()) : "";
                po_value = "";
                deliveryDate = "";
                order_stock = "";
            } else{
                sizeKey = reel.type == "sheet" ? (((reel.reel_size) + " x " + (reel.length) + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase())) : (reel.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase());
                po_value = reel.po ? reel.po : "";
                deliveryDate = reel.reel_type == "order" ? reel.delivery_date : "";
                order_stock = reel.reel_type == "order" ? (reel.order_no ? reel.order_no : "" ) : (reel.stock_no ? reel.stock_no : "");
            }
            
            return {
                reelNo: reel.id,
                jc_code: formattedCode,
                mill_item_no: reel.number,
                size: sizeKey,
                order_stock_no: order_stock,
                po_no: po_value,
                product_spec: reel?.product?.product_spec ? reel?.product?.product_spec : "",
                produced_qty: reel.weight + " " + capitalize(weightUnit[reel.units?.weight]?.displayName),
                // physical_qty: reel.type == "sheet" ? (reel.actual_produced_weight + " " + capitalize(weightUnit[reel.units?.actual_produced_weight]?.displayName)) : (reel.actual_weight + " " + capitalize(weightUnit[reel?.units?.actual_weight]?.displayName)),
                physical_qty: reel.actual_produced_weight + " " + capitalize(weightUnit[reel.units?.actual_produced_weight]?.displayName),
                accepted_qty: reel.accepted_weight + " " + capitalize(weightUnit[reel.units?.accepted_weight]?.displayName),
                rejected_qty: reel.rejected_weight + " " + capitalize(weightUnit[reel.units?.rejected_weight]?.displayName),
                remarks:reel.comments.length !== 0 ? reel.comments[reel.comments.length - 1] : null,
                jobcard_no: reel.jobcard,
                combination_no: reel.combination_no,
                parent_set: reel.parent_reel ? reel.parent_reel : reel.cutting_pattern,
                finishing_date: reel.type == "sheet" ? (reel.cutting_date ? moment(reel.cutting_date).format("DD MMM YYYY") : "") :(reel.rewinding_date ? moment(reel.rewinding_date).format("DD MMM YYYY") : ""),
                finishing_shift: reel.type == "sheet" ? reel.cutting_shift : reel.rewinding_shift,
                dispatch_date: reel.dispatch_date ? moment(reel.dispatch_date).format("DD MMM YYYY") : "",
                delivery_date: deliveryDate ?  moment(deliveryDate).format("DD MMM YYYY") : "",
                closing_date: reel.closing_date ?  moment(reel.closing_date).format("DD MMM YYYY") : "",
                priority: reel.priority,
                units: reel.units,
                type: reel.type,
                status: reel.status,
                reel_type: reel.reel_type,
                reel_size: reel.reel_size,
                reel_data: reel.reel_data,
                product: reel.product,
                order: reel.order,
                stock: reel.stock,
                includes_core_weight: reel.includes_core_weight,
                includes_packaging_weight: reel.includes_packaging_weight,
                jobcard_type: reel.jobcard_type,
            };
          });
          setTodaysRecord(list);
          setTotalTodaysRecords(resp.data.data.total_reels);
          setTodaysRecordLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setTodaysRecordLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    };

    const fetchYesterdaysRecordDetails = (params) => {
      let startEndDate = getYesterdaysDate();
      // let day = (yesterdaysDate.getDate() - 1);
      // let month = "" + (yesterdaysDate.getMonth() + 1);
      // let year = yesterdaysDate.getFullYear();
      // let startEndDate = year + "-" + month + "-" + day;
      let filterData = [
        {
          type: "closing_date",
          "start_date": startEndDate,
          "end_date": startEndDate
          // start_date: "2024-01-31",
          // end_date: "2024-01-31",
        },
        {
          type: "reel_type",
          reel_type: selectedReelTypeRef.current
        },
      ];
      getMultistageProductionDetails(filterData, params)
        .then((resp) => {
          if (!resp.data.data.reels.length) {
            setEmptyStateLabel("noData");
          }
          setTotalCount();
        //   console.log(resp.data.data.reels);
          const list = resp.data.data.reels.map((reel) => {
            let sizeKey;
            let po_value;
            let deliveryDate;
            let order_stock;
            let formattedCode = getJCCode(reel.jobcard_code);
            if(reel.type == "intermediate"){
                sizeKey = reel?.reel_size ? (reel?.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase()) : "";
                po_value = "";
                deliveryDate = "";
                order_stock = "";
            } else{
                sizeKey = reel.type == "sheet" ? (((reel.reel_size) + " x " + (reel.length) + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase())) : (reel.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase());
                po_value = reel.po ? reel.po : "";
                deliveryDate = reel.reel_type == "order" ? reel.delivery_date : "";
                order_stock = reel.reel_type == "order" ? (reel.order_no ? reel.order_no : "" ) : (reel.stock_no ? reel.stock_no : "");
            }
            
            return {
                reelNo: reel.id,
                jc_code: formattedCode,
                mill_item_no: reel.number,
                size: sizeKey,
                order_stock_no: order_stock,
                po_no: po_value,
                product_spec: reel?.product?.product_spec ? reel?.product?.product_spec : "",
                produced_qty: reel.weight + " " + capitalize(weightUnit[reel.units?.weight]?.displayName),
                // physical_qty: reel.type == "sheet" ? (reel.actual_produced_weight + " " + capitalize(weightUnit[reel.units?.actual_produced_weight]?.displayName)) : (reel.actual_weight + " " + capitalize(weightUnit[reel?.units?.actual_weight]?.displayName)),
                physical_qty: reel.actual_produced_weight + " " + capitalize(weightUnit[reel.units?.actual_produced_weight]?.displayName),
                accepted_qty: reel.accepted_weight + " " + capitalize(weightUnit[reel.units?.accepted_weight]?.displayName),
                rejected_qty: reel.rejected_weight + " " + capitalize(weightUnit[reel.units?.rejected_weight]?.displayName),
                remarks:reel.comments.length !== 0 ? reel.comments[reel.comments.length - 1] : null,
                jobcard_no: reel.jobcard,
                combination_no: reel.combination_no,
                parent_set: reel.parent_reel ? reel.parent_reel : reel.cutting_pattern,
                finishing_date: reel.type == "sheet" ? (reel.cutting_date ? moment(reel.cutting_date).format("DD MMM YYYY") : "") :(reel.rewinding_date ? moment(reel.rewinding_date).format("DD MMM YYYY") : ""),
                finishing_shift: reel.type == "sheet" ? reel.cutting_shift : reel.rewinding_shift,
                dispatch_date: reel.dispatch_date ? moment(reel.dispatch_date).format("DD MMM YYYY") : "",
                delivery_date: deliveryDate ?  moment(deliveryDate).format("DD MMM YYYY") : "",
                closing_date: reel.closing_date ?  moment(reel.closing_date).format("DD MMM YYYY") : "",
                priority: reel.priority,
                units: reel.units,
                type: reel.type,
                status: reel.status,
                reel_type: reel.reel_type,
                reel_size: reel.reel_size,
                reel_data: reel.reel_data,
                product: reel.product,
                order: reel.order,
                stock: reel.stock,
                includes_core_weight: reel.includes_core_weight,
                includes_packaging_weight: reel.includes_packaging_weight,
                jobcard_type: reel.jobcard_type
            };
          });
          setYesterdaysRecord(list);
          setTotalYesterdaysRecord(resp.data.data.total_reels);
          setYesterdaysRecordLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setYesterdaysRecordLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    };

    const fetchAllRecordDetails = (params) => {
      let filterData = [
        {
          type: "reel_type",
          reel_type: selectedReelTypeRef.current
      },
      ];
      getMultistageProductionDetails(filterData, params)
      .then((resp) => {
          if (!resp.data.data.reels.length) {
            setEmptyStateLabel("noData");
          }
          setTotalCount(resp.data.data.total_reels);
        //   console.log(resp.data.data.reels);
          const list = resp.data.data.reels.map((reel) => {
            let sizeKey;
            let po_value;
            let deliveryDate;
            let order_stock;
            let formattedCode = getJCCode(reel.jobcard_code);
            if(reel.type == "intermediate"){
                sizeKey = reel?.reel_size ? (reel?.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase()) : "";
                po_value = "";
                deliveryDate = "";
                order_stock = "";
            } else{
                sizeKey = reel.type == "sheet" ? (((reel.reel_size) + " x " + (reel.length) + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase())) : (reel.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase());
                po_value = reel.po ? reel.po : "";
                deliveryDate = reel.reel_type == "order" ? reel.delivery_date : "";
                order_stock = reel.reel_type == "order" ? (reel.order_no ? reel.order_no : "" ) : (reel.stock_no ? reel.stock_no : "");
            }
            
            return {
                reelNo: reel.id,
                jc_code: formattedCode,
                mill_item_no: reel.number,
                size: sizeKey,
                order_stock_no: order_stock,
                po_no: po_value,
                product_spec: reel?.product?.product_spec ? reel?.product?.product_spec : "",
                produced_qty: reel.weight + " " + capitalize(weightUnit[reel.units?.weight]?.displayName),
                // physical_qty: reel.type == "sheet" ? (reel.actual_produced_weight + " " + capitalize(weightUnit[reel.units?.actual_produced_weight]?.displayName)) : (reel.actual_weight + " " + capitalize(weightUnit[reel?.units?.actual_weight]?.displayName)),
                physical_qty: reel.actual_produced_weight + " " + capitalize(weightUnit[reel.units?.actual_produced_weight]?.displayName),
                accepted_qty: reel.accepted_weight + " " + capitalize(weightUnit[reel.units?.accepted_weight]?.displayName),
                rejected_qty: reel.rejected_weight + " " + capitalize(weightUnit[reel.units?.rejected_weight]?.displayName),
                remarks: reel.comments.length !== 0 ? reel.comments[reel.comments.length - 1] : null,
                jobcard_no: reel.jobcard,
                combination_no: reel.combination_no,
                parent_set: reel.parent_reel ? reel.parent_reel : reel.cutting_pattern,
                finishing_date: reel.type == "sheet" ? (reel.cutting_date ? moment(reel.cutting_date).format("DD MMM YYYY") : "") :(reel.rewinding_date ? moment(reel.rewinding_date).format("DD MMM YYYY") : ""),
                finishing_shift: reel.type == "sheet" ? reel.cutting_shift : reel.rewinding_shift,
                dispatch_date: reel.dispatch_date ? moment(reel.dispatch_date).format("DD MMM YYYY") : "",
                delivery_date: deliveryDate ?  moment(deliveryDate).format("DD MMM YYYY") : "",
                closing_date: reel.closing_date ?  moment(reel.closing_date).format("DD MMM YYYY") : "",
                priority: reel.priority,
                units: reel.units,
                type: reel.type,
                status: reel.status,
                reel_type: reel.reel_type,
                reel_size: reel.reel_size,
                reel_data: reel.reel_data,
                product: reel.product,
                order: reel.order,
                stock: reel.stock,
                includes_core_weight: reel.includes_core_weight,
                includes_packaging_weight: reel.includes_packaging_weight,
                jobcard_type: reel.jobcard_type,
            };
          });
          setAllRecord(list);
          setTotalAllRecord(resp.data.data.total_reels);
          setAllRecordLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setAllRecordLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    };

    const getData = () => {
      const list = allData.map((reel) => {
        let sizeKey;
        let po_value;
        let deliveryDate;
        let order_stock;
        let formattedCode = getJCCode(reel.jobcard_code);
        if(reel.type == "intermediate"){
          sizeKey = reel?.reel_size ? (reel?.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase()) : "";
          po_value = "";
          deliveryDate = "";
          order_stock = "";
      } else{
          sizeKey = reel.type == "sheet" ? (((reel.reel_size) + " x " + (reel.length) + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase())) : (reel.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase());
          po_value = reel.po ? reel.po : "";
          deliveryDate = reel.reel_type == "order" ? reel.delivery_date : "";
          order_stock = reel.reel_type == "order" ? (reel.order_no ? reel.order_no : "" ) : (reel.stock_no ? reel.stock_no : "");
      }

        return {
          reelNo: reel.id,
          jc_code: formattedCode,
          mill_item_no: reel.number,
          size: sizeKey,
          order_stock_no: order_stock,
          po_no: po_value,
          product_spec: reel?.product?.product_spec
            ? reel?.product?.product_spec
            : "",
          produced_qty:
            reel.weight +
            " " +
            capitalize(weightUnit[reel.units?.weight]?.displayName),
            // physical_qty: reel.type == "sheet" ? (reel.actual_produced_weight + " " + capitalize(weightUnit[reel.units?.actual_produced_weight]?.displayName)) : (reel.actual_weight + " " + capitalize(weightUnit[reel?.units?.actual_weight]?.displayName)),
            physical_qty: reel.actual_produced_weight + " " + capitalize(weightUnit[reel.units?.actual_produced_weight]?.displayName),
          accepted_qty:
            reel.accepted_weight +
            " " +
            capitalize(weightUnit[reel.units?.accepted_weight]?.displayName),
          rejected_qty:
            reel.rejected_weight +
            " " +
            capitalize(weightUnit[reel.units?.rejected_weight]?.displayName),
          remarks:
            reel.comments.length !== 0
              ? reel.comments[reel.comments.length - 1]
              : null,
          jobcard_no: reel.jobcard,
          combination_no: reel.combination_no,
          parent_set: reel.parent_reel,
          finishing_date: reel.rewinding_date
            ? moment(reel.rewinding_date).format("DD MMM YYYY")
            : "",
          finishing_shift: reel.rewinding_shift,
          dispatch_date: reel.dispatch_date
            ? moment(reel.dispatch_date).format("DD MMM YYYY")
            : "",
            delivery_date: deliveryDate
          ? moment(deliveryDate).format("DD MMM YYYY")
          : "",
          closing_date: reel.closing_date ?  moment(reel.closing_date).format("DD MMM YYYY") : "",
          priority: reel.priority,
          units: reel.units,
          type: reel.type,
          status: reel.status,
          reel_type: reel.reel_type,
          reel_size: reel.reel_size,
          reel_data: reel.reel_data,
          product: reel.product,
          order: reel.order,
          stock: reel.stock,
          includes_core_weight: reel.includes_core_weight,
          includes_packaging_weight: reel.includes_packaging_weight,
          jobcard_type: reel.jobcard_type
        };
      });
      return list;
    };

    const fetchFilterdTodaysRecordDetails = (params) => {
      let todaysDate = new Date();
      let month = "" + (todaysDate.getMonth() + 1);
      let day = "" + todaysDate.getDate();
      let year = todaysDate.getFullYear();
      let startEndDate = year + "-" + month + "-" + day;
      let filterData = [
        ...appliedFilters,
        {
          type: "closing_date",
          "start_date": startEndDate,
          "end_date": startEndDate
          // start_date: "2024-01-31",
          // end_date: "2024-01-31",
        },
        {
          type: "reel_type",
          reel_type: selectedReelTypeRef.current,
        },
      ];
      getMultistageProductionDetails(filterData, params)
        .then((resp) => {
          if (!resp.data.data.reels.length) {
            setEmptyStateLabel("noData");
          }
          setTotalCount(resp.data.data.total_reels);
          //   console.log(resp.data.data.reels);
          setAllData(resp.data.data.reels);
          setTotalTodaysRecords(resp.data.data.total_reels);
          setTodaysRecordLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setTodaysRecordLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    };

    const fetchFilterdYesterdaysRecordDetails = (params) => {
      let startEndDate = getYesterdaysDate();
      // let day = yesterdaysDate.getDate() - 1;
      // let month = "" + (yesterdaysDate.getMonth() + 1);
      // let year = yesterdaysDate.getFullYear();
      // let startEndDate = year + "-" + month + "-" + day;
      let filterData = [
        ...appliedFilters,
        {
          type: "closing_date",
          "start_date": startEndDate,
          "end_date": startEndDate
          // start_date: "2024-01-31",
          // end_date: "2024-01-31",
        },
        {
          type: "reel_type",
          reel_type: selectedReelTypeRef.current,
        },
      ];
      getMultistageProductionDetails(filterData, params)
        .then((resp) => {
          if (!resp.data.data.reels.length) {
            setEmptyStateLabel("noData");
          }
          setTotalCount(resp.data.data.total_reels);
          //   console.log(resp.data.data.reels);
          setAllData(resp.data.data.reels);
          setTotalYesterdaysRecord(resp.data.data.total_reels);
          setYesterdaysRecordLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setYesterdaysRecordLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    };

    const fetchFilterdAllRecordDetails = (params) => {
      let filterData = [
        ...appliedFilters,
        {
          type: "reel_type",
          reel_type: selectedReelTypeRef.current,
        },
      ];
      getMultistageProductionDetails(filterData, params)
        .then((resp) => {
          if (!resp.data.data.reels.length) {
            setEmptyStateLabel("noData");
          }
          setTotalCount(resp.data.data.total_reels);
          //   console.log(resp.data.data.reels);
          setAllData(resp.data.data.reels);
          setTotalAllRecord(resp.data.data.total_reels);
          setAllRecordLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setAllRecordLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    };

    const searchTodaysRecordDetails = (params, pattern) => {
      let todaysDate = new Date();
      let month = "" + (todaysDate.getMonth() + 1);
      let day = "" + todaysDate.getDate();
      let year = todaysDate.getFullYear();
      let startEndDate = year + "-" + month + "-" + day;
      let filterData = [
        {
          type: "closing_date",
          "start_date": startEndDate,
          "end_date": startEndDate
          // start_date: "2024-01-31",
          // end_date: "2024-01-31",
        },
        {
          type: "reel_type",
          reel_type: selectedReelTypeRef.current,
        },
      ];
      searchMultistageFilteredProductionDetails(filterData, params, pattern)
        .then((resp) => {
          if (!resp.data.data.reels.length) {
            setEmptyStateLabel("noData");
          }
          setTotalCount(resp.data.data.total_reels);
          //   console.log(resp.data.data.reels);
          setAllData(resp.data.data.reels);
          setTotalTodaysRecords(resp.data.data.total_reels);
          setTodaysRecordLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setTodaysRecordLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    };

    const searchYesterdaysRecordDetails = (params, pattern) => {
      let startEndDate = getYesterdaysDate();
      // let day = yesterdaysDate.getDate() - 1;
      // let month = "" + (yesterdaysDate.getMonth() + 1);
      // let year = yesterdaysDate.getFullYear();
      // let startEndDate = year + "-" + month + "-" + day;
      let filterData = [
        {
          type: "closing_date",
          "start_date": startEndDate,
          "end_date": startEndDate
          // start_date: "2024-01-31",
          // end_date: "2024-01-31",
        },
        {
          type: "reel_type",
          reel_type: selectedReelTypeRef.current,
        },
      ];
      searchMultistageFilteredProductionDetails(filterData, params, pattern)
        .then((resp) => {
          if (!resp.data.data.reels.length) {
            setEmptyStateLabel("noData");
          }
          setTotalCount(resp.data.data.total_reels);
          //   console.log(resp.data.data.reels);
          setAllData(resp.data.data.reels);
          setTotalYesterdaysRecord(resp.data.data.total_reels);
          setYesterdaysRecordLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setYesterdaysRecordLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    };

    const searchAllRecordDetails = (params, pattern) => {
      let filterData = [
        {
          type: "reel_type",
          reel_type: selectedReelTypeRef.current,
        },
      ];
      searchMultistageFilteredProductionDetails(filterData, params, pattern)
        .then((resp) => {
          if (!resp.data.data.reels.length) {
            setEmptyStateLabel("noData");
          }
          setTotalCount(resp.data.data.total_reels);
          //   console.log(resp.data.data.reels);
          setAllData(resp.data.data.reels);
          setTotalAllRecord(resp.data.data.total_reels);
          setAllRecordLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setAllRecordLoading(false);
          setEmptyStateLabel("connectionAPIError");
        });
    };

    const getJCCode = (str) => {
      if(str){
        let splittedString = str?.split("~");
        let mergeString;
        mergeString = splittedString?.join("");
        return mergeString;
      }
    }

    const applyfilter = (filter) => {
      setTodaysRecord([]);
      setYesterdaysRecord([]);
      setAllRecord([]);
      if (currentTab === "1") {
        todaysColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }

      if (currentTab === "2") {
        yesterdaysColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }

      if (currentTab === "3") {
        allRecordsColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }

      let temp = appliedFilters;
      let alreadySetFilter = false;
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].type === filter.type) {
          temp[i] = filter;
          alreadySetFilter = true;
        }
      }

      setCurrentPage(1);
      const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
      setAppliedFilters(tempVar);
      setFilterTags(tempVar.map(formatFilters));
      paginationRefForAllTableParams.current = {
        ...paginationRefForAllTableParams.current,
        page: 1,
        size: 10,
      };
      setTableParams({
        ...tableParams,
        page: 1,
        size: 10,
      });
      setRendering(true);
    };

    const formatFilters = (item) => {
      switch (item.type) {
        case "customer":
          const value =
            item.names.length > 1
              ? `${item.names[0]} or ${item.names.length - 1} others`
              : `${item.names[0]}`;
          // const concatString = item.names.join(" or ");
          // const customerToolTip = `Country equals ${concatString}`;
          return {
            type: item.type,
            formattedType: "Customer",
            operand: "equals",
            value,
            // tooltip: customerToolTip,
          };
        case "consignee":
          const consigneeValue =
            item.names.length > 1
              ? `${item.names[0]} or ${item.names.length - 1} others`
              : `${item.names[0]}`;
          // const concatString = item.names.join(" or ");
          // const customerToolTip = `Country equals ${concatString}`;
          return {
            type: item.type,
            formattedType: "Consignee",
            operand: "equals",
            value: consigneeValue,
            // tooltip: customerToolTip,
          };
        case "order_type":
          const typeValue =
            item.order_type === "reel"
              ? "Reel"
              : item.order_type === "sheet"
              ? "Sheet"
              : "Reel or Sheet";
          return {
            type: item.type,
            formattedType: "Order Type",
            operand: "equals",
            value: typeValue,
            // tooltip: `Order Type equals ${typeValue}`,
          };
        case "created_date":
          let dateOperand = "";
          let dateValue = "";
          if (item.start_date === item.end_date) {
            dateOperand = "-";
            dateValue = moment(item.start_date).format("DD MMMM YY");
          } else {
            dateOperand = "between";
            dateValue = `${moment(item.start_date).format(
              "DD MMMM YY"
            )} - ${moment(item.end_date).format("DD MMMM YY")}`;
          }
          return {
            type: item.type,
            formattedType: "Created date",
            operand: dateOperand,
            value: dateValue,
          };
        case "po_date":
          let poDateOperand = "";
          let poDateValue = "";
          if (item.start_date === item.end_date) {
            poDateOperand = "-";
            poDateValue = moment(item.start_date).format("DD MMMM YY");
          } else {
            poDateOperand = "between";
            poDateValue = `${moment(item.start_date).format(
              "DD MMMM YY"
            )} - ${moment(item.end_date).format("DD MMMM YY")}`;
          }
          return {
            type: item.type,
            formattedType: "PO date",
            operand: poDateOperand,
            value: poDateValue,
          };
        case "delivery_date":
          let deliveryDateOperand = "";
          let deliveryDateValue = "";
          if (item.start_date === item.end_date) {
            deliveryDateOperand = "-";
            deliveryDateValue = moment(item.start_date).format("DD MMMM YY");
          } else {
            deliveryDateOperand = "between";
            deliveryDateValue = `${moment(item.start_date).format(
              "DD MMMM YY"
            )} - ${moment(item.end_date).format("DD MMMM YY")}`;
          }
          return {
            type: item.type,
            formattedType: "Delivery date",
            operand: deliveryDateOperand,
            value: deliveryDateValue,
          };
        case "gsm":
          const gsmValue =
            item.operator === "in_range"
              ? `${item.min_gsm} and ${item.max_gsm}`
              : `${item.gsm}`;
          const gsmOperand =
            item.operator === "in_range"
              ? "between"
              : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
              ? "less than"
              : item.operator === "greater_than"
              ? "greater than"
              : "";
          return {
            type: item.type,
            formattedType: "GSM",
            operand: gsmOperand,
            value: gsmValue,
            // tooltip: `GSM ${gsmOperand} ${gsmValue}`,
          };
        case "burst_factor":
          const bfValue =
            item.operator === "in_range"
              ? `${item.min_burst_factor} and ${item.max_burst_factor}`
              : `${item.burst_factor}`;
          const bfOperand =
            item.operator === "in_range"
              ? "between"
              : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
              ? "less than"
              : item.operator === "greater_than"
              ? "greater than"
              : "";
          return {
            type: item.type,
            formattedType: "Burst factor",
            operand: bfOperand,
            value: bfValue,
            // tooltip: `Burst factor ${bfOperand} ${bfValue}`,
          };
        case "reel_od":
          const reelOdValue =
            item.operator === "in_range"
              ? `${item.min_reel_od} and ${item.max_reel_od}`
              : `${item.reel_od}`;
          const reelOdOperand =
            item.operator === "in_range"
              ? "between"
              : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
              ? "less than"
              : item.operator === "greater_than"
              ? "greater than"
              : "";
          return {
            type: item.type,
            formattedType: "Reel OD",
            operand: reelOdOperand,
            value: reelOdValue,
            // tooltip: `Reel OD ${reelOdOperand} ${reelOdValue}`,
          };
        case "core_id":
          const coreIdValue =
            item.operator === "in_range"
              ? `${item.min_core_id} and ${item.max_core_id}`
              : `${item.core_id}`;
          const coreIdOperand =
            item.operator === "in_range"
              ? "between"
              : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
              ? "less than"
              : item.operator === "greater_than"
              ? "greater than"
              : "";
          return {
            type: item.type,
            formattedType: "Core ID",
            operand: coreIdOperand,
            value: coreIdValue,
            // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`,
          };
        case "grade_quality":
          const gradeValue =
            item.grades.length > 1
              ? `${
                  item.grades[0].grade
                }(${item.grades[0].qualities.join()}) or ${
                  item.grades.length - 1
                } others`
              : `${item.grades[0].grade}` +
                (item.grades[0].qualities?.length
                  ? `"(${item.grades[0].qualities.join()})"`
                  : ``);
          return {
            type: item.type,
            formattedType: "Grade",
            operand: "-",
            value: gradeValue,
            // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`
          };
        case "size":
          const sizeValue =
            item.operator === "in_range"
              ? `${item.min_size} and ${item.max_size}`
              : `${item.size}`;
          const sizetype =
            item.size_type === "width"
              ? "Width"
              : item.size_type === "length"
              ? "Length"
              : "Width / Length";
          const sizeOperand =
            item.operator === "in_range"
              ? "between"
              : item.operator === "equal_to"
              ? "equals"
              : item.operator === "less_than"
              ? "less than"
              : item.operator === "greater_than"
              ? "greater than"
              : "";
          return {
            type: item.type,
            formattedType: sizetype,
            operand: sizeOperand,
            value: sizeValue,
            // tooltip: `${sizetype} ${sizeOperand} ${sizeValue}`,
          };
        case "machine":
          const machineValue =
            item.machine_code.length > 1
              ? `${item.machine_code[0]} or ${
                  item.machine_code.length - 1
                } others`
              : `${item.machine_code[0]}`;
          return {
            type: item.type,
            formattedType: "Machine",
            operand: "equals",
            value: machineValue,
          };
        case "item_type":
          const itemValue =
            item.item_type === "order"
              ? "Order"
              : item.item_type === "stock"
              ? "Stock"
              : "Order or Stock";
          return {
            type: item.type,
            formattedType: "Item Type",
            operand: "equals",
            value: itemValue,
            // tooltip: `Order Type equals ${typeValue}`,
          };
      }
    };

    const removeFilter = (filter) => {
      setTodaysRecord([]);
      setYesterdaysRecord([]);
      setAllRecord([]);
      if (currentTab === "1") {
        todaysColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }

      if (currentTab === "2") {
        yesterdaysColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }

      if (currentTab === "3") {
        allRecordsColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }
      const filterList = appliedFilters.filter((item) => {
        return item.type !== filter.type;
      });
      const formattedFilterList = filterTags.filter((item) => {
        return item.type !== filter.type;
      });
      setFilterTags(formattedFilterList);
      setAppliedFilters(filterList);
      setSearchValue("");
      setClearSearch(true);
      setCurrentPage(1);

      paginationRefForAllTableParams.current = {
        ...paginationRefForAllTableParams.current,
        page: 1,
        size: 10,
      };
      setTableParams({
        ...tableParams,
        page: 1,
        size: 10,
      });
      setRendering(true);
    };

    const exportHandler = () => {
      const currentDate = new Date();
      const today = currentDate.getDate() + "/" + currentDate.toLocaleString("default", { month: "long" }) + "/" + currentDate.getFullYear();
      let fileName = "Kaiznn Production Details_" + today;

      if (appliedFilters.length) {
        let filterData;
        if (currentTab == "1"){
          let todaysDate = new Date();
          let month = "" + (todaysDate.getMonth() + 1);
          let day = "" + todaysDate.getDate();
          let year = todaysDate.getFullYear();
          let startEndDate = year + "-" + month + "-" + day;
          filterData = [
            {
              type: "closing_date",
              "start_date": startEndDate,
              "end_date": startEndDate
              // start_date: "2024-01-31",
              // end_date: "2024-01-31",
            },
            {
              type: "reel_type",
              reel_type: selectedReelTypeRef.current,
            },
            ...appliedFilters,
          ];          
        }
        if (currentTab == "2"){
          let startEndDate = getYesterdaysDate();
          // let day = yesterdaysDate.getDate() - 1;
          // let month = "" + (yesterdaysDate.getMonth() + 1);
          // let year = yesterdaysDate.getFullYear();
          // let startEndDate = year + "-" + month + "-" + day;
          filterData = [
            ...appliedFilters,
            {
              type: "closing_date",
              "start_date": startEndDate,
              "end_date": startEndDate
              // start_date: "2024-01-31",
              // end_date: "2024-01-31",
            },
            {
              type: "reel_type",
              reel_type: selectedReelTypeRef.current,
            },
          ];
        }
        if (currentTab == "3"){
          filterData = [
            ...appliedFilters,
            {
              type: "reel_type",
              reel_type: selectedReelTypeRef.current,
            },
          ];
        }
        navigate("../production-detail/export-production-details", {
          state: {
            body: {
              page: "production details",
              type: "Filter",
              appliedFilters: filterData,
              sortParams: {
                sort_by: paginationRefForAllTableParams.current.sort_by,
                sort_type: paginationRefForAllTableParams.current.sort_by,
              },
            },
            rootPage: "../production-detail",
            fileName: fileName,
            count: totalCount
          },
        });
      } else if (searchValue && searchValue !== "") {
        let filterData;
        if (currentTab == "1"){
          let todaysDate = new Date();
          let month = "" + (todaysDate.getMonth() + 1);
          let day = "" + todaysDate.getDate();
          let year = todaysDate.getFullYear();
          let startEndDate = year + "-" + month + "-" + day;
          filterData = [
            {
              type: "closing_date",
              "start_date": startEndDate,
              "end_date": startEndDate
              // start_date: "2024-01-31",
              // end_date: "2024-01-31",
            },
            {
              type: "reel_type",
              reel_type: selectedReelTypeRef.current,
            },
            ...appliedFilters,
          ];
        }
        if (currentTab == "2"){
          let startEndDate = getYesterdaysDate();
          // let day = yesterdaysDate.getDate() - 1;
          // let month = "" + (yesterdaysDate.getMonth() + 1);
          // let year = yesterdaysDate.getFullYear();
          // let startEndDate = year + "-" + month + "-" + day;
          filterData = [
            {
              type: "closing_date",
              "start_date": startEndDate,
              "end_date": startEndDate
              // start_date: "2024-01-31",
              // end_date: "2024-01-31",
            },
            {
              type: "reel_type",
              reel_type: selectedReelTypeRef.current,
            },
            ...appliedFilters,
          ];
        }
        if (currentTab == "3"){
          filterData = [
            ...appliedFilters,
            {
              type: "reel_type",
              reel_type: selectedReelTypeRef.current,
            },
          ];
        }
        navigate("../production-detail/export-production-details", {
          state: {
            body: {
              page: "production details",
              type: "Search",
              appliedFilters: filterData,
              sortParams: {
                sort_by: paginationRefForAllTableParams.current.sort_by,
                sort_type: paginationRefForAllTableParams.current.sort_by,
              },
              searchValue: searchValue
            },
            rootPage: "../production-detail",
            fileName: fileName,
            count: totalCount
          },
        });
      } else {
        let filterData;
        if (currentTab == "1"){
          let todaysDate = new Date();
      let month = "" + (todaysDate.getMonth() + 1);
      let day = "" + todaysDate.getDate();
      let year = todaysDate.getFullYear();
          let startEndDate = year + "-" + month + "-" + day;
          filterData = [
            {
              type: "closing_date",
              "start_date": startEndDate,
              "end_date": startEndDate
              // start_date: "2024-01-31",
              // end_date: "2024-01-31",
            },
            {
              type: "reel_type",
              reel_type: selectedReelTypeRef.current
            },
          ];
        }
        if (currentTab == "2"){
          let yesterdaysDate = new Date();
          let day = (yesterdaysDate.getDate() - 1);
          let month = "" + (yesterdaysDate.getMonth() + 1);
          let year = yesterdaysDate.getFullYear();
          let startEndDate = year + "-" + month + "-" + day;
          filterData = [
            {
              type: "closing_date",
              "start_date": startEndDate,
              "end_date": startEndDate
              // start_date: "2024-01-31",
              // end_date: "2024-01-31",
            },
            {
              type: "reel_type",
              reel_type: selectedReelTypeRef.current
            },
          ];
        }
        if (currentTab == "3"){
          filterData = [
          {
            type: "reel_type",
            reel_type: selectedReelTypeRef.current
          },
          ];
        }
        navigate("../production-detail/export-production-details", {
          state: {
            body: {
              page: "production details",
              type: "All Data",
              appliedFilters: filterData,
              sortParams: {
                sort_by: paginationRefForAllTableParams.current.sort_by,
                sort_type: paginationRefForAllTableParams.current.sort_by,
              },
            },
            rootPage: "../production-detail",
            fileName: fileName,
            count: totalCount
          },
        });
      }

    };

    const searchOrders = async (value = "") => {
      setTodaysRecord([]);
      setYesterdaysRecord([]);
      setAllRecord([]);
      setTodaysRecordLoading(true);
      setYesterdaysRecordLoading(true);
      setAllRecordLoading(true);
      if (currentTab === "1") {
        todaysColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }

      if (currentTab === "2") {
        yesterdaysColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }

      if (currentTab === "3") {
        allRecordsColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }
      paginationRefForAllTableParams.current = {
        ...paginationRefForAllTableParams.current,
        page: 1,
        size: 10,
      };
      setTableParams({
        ...tableParams,
        page: 1,
        size: 10,
      });
      setAppliedFilters([]);
      setFilterTags([]);
      setSearchValue(value);
      if (value === "" || value === null) {
        //fetchOrdersList(paginationRef.current, sortParams, orderState);

        if (currentTab == 1) {
          fetchTodaysRecordDetails(paginationRefForAllTableParams.current);
        } else if (currentTab == 2) {
          fetchYesterdaysRecordDetails(paginationRefForAllTableParams.current);
        } else {
          fetchAllRecordDetails(paginationRefForAllTableParams.current);
        }
      } else {
        setClearSearch(false);
        if (currentTab == "1")
          searchTodaysRecordDetails(
            paginationRefForAllTableParams.current,
            value
          );
        else if (currentTab == "2")
          searchYesterdaysRecordDetails(
            paginationRefForAllTableParams.current,
            value
          );
        else
          searchAllRecordDetails(paginationRefForAllTableParams.current, value);
      }
    };

    const onReelTypeChange = (type) => {
      setTodaysRecord([]);
      setYesterdaysRecord([]);
      setAllRecord([]);
      if (currentTab === "1") {
        todaysColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }

      if (currentTab === "2") {
        yesterdaysColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }

      if (currentTab === "3") {
        allRecordsColumnsHead.current?.map((item) => {
          item["sortOrder"] = null;
        });
      }
      selectedReelTypeRef.current = type;
      setSelectedReelType(type);

      setCurrentPage(1);
      paginationRefForAllTableParams.current = {
        ...paginationRefForAllTableParams.current,
        page: 1,
        size: 10,
      };
      setTableParams({
        ...tableParams,
        page: 1,
        size: 10,
      });

      setRendering(true);
    };

    useEffect(() => {
      setAllRecord(allData.length ? getData() : []);
      setTodaysRecord(allData.length ? getData() : []);
      setYesterdaysRecord(allData.length ? getData() : []);
    }, [allData]);

    useEffect(() => {
      let propsData = {};
      if (emptyStateLabel === "noData") {
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "No records in this list";
        propsData["subHeading"] =
          "There are no records to show in this list. Add your first record to view details here";
      } else if (emptyStateLabel === "search") {
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "No records found";
        propsData["subHeading"] =
          "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
      } else if (emptyStateLabel === "filter") {
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "No records found";
        propsData["subHeading"] =
          "There is no record matching your filter. Try changing your filter to find what you are looking for.";
      } else {
        propsData["label"] = emptyStateLabel;
        propsData["heading"] = "Something went wrong";
        propsData["subHeading"] =
          "Check your internet connection or try reloading the page.";
      }
      setEmptyStatePropsData(propsData);
    }, [emptyStateLabel]);

    useEffect(() => {
      setTodaysRecordLoading(true);
      setYesterdaysRecordLoading(true);
      setAllRecordLoading(true);
      if (rendering) {
        if (!appliedFilters.length && searchValue == "") {
          if (currentTab == 1) {
            fetchTodaysRecordDetails(paginationRefForAllTableParams.current);
          } else if (currentTab == 2) {
            fetchYesterdaysRecordDetails(
              paginationRefForAllTableParams.current
            );
          } else {
            fetchAllRecordDetails(paginationRefForAllTableParams.current);
          }
          setRendering(false);
        } else if (appliedFilters.length) {
          if (currentTab == "1")
            fetchFilterdTodaysRecordDetails(
              paginationRefForAllTableParams.current
            );
          else if (currentTab == "2")
            fetchFilterdYesterdaysRecordDetails(
              paginationRefForAllTableParams.current
            );
          else
            fetchFilterdAllRecordDetails(
              paginationRefForAllTableParams.current
            );
          setRendering(false);
        } else if (searchValue !== "") {
          if (currentTab == "1")
            searchTodaysRecordDetails(
              paginationRefForAllTableParams.current,
              searchValue
            );
          else if (currentTab == "2")
            searchYesterdaysRecordDetails(
              paginationRefForAllTableParams.current,
              searchValue
            );
          else
            searchAllRecordDetails(
              paginationRefForAllTableParams.current,
              searchValue
            );
          setRendering(false);
        }
      }
    }, [selectedReelType, rendering]);

    return (
      <RightLayoutContainer>
        <PageTitleComp style={{ borderBottom: "0" }}>
          <PageHeader ghost={false} title="Production Details"></PageHeader>
        </PageTitleComp>
        <TableLayoutData>
          <div className="tableDataFormat">
            <StyledTab>
              <Tabs onChange={handleTabChange}>
                <Panes tab="Today's Records" key="1">
                  <>
                   <SearchContainer
                   placeholder={"Search Order No, Stock or PO No."}
                   fetchOrder={searchOrders}
                   exportRole={todaysRecord?.length ? true : false}
                   exportTrigger={exportHandler}
                   clearSearch={clearSearch}
                   setClearSearch={setClearSearch}
                   paginationParams={tableParams}
                   searchedValue={searchValue}
                   filterOptions={[
                     
                     {
                       key: 0,
                       label: "Filter by GSM",
                       value: "gsm",
                       type: "inputSelect",
                     },
                     {
                       key: 1,
                       label: "Filter by Grade/Quality",
                       value: "grade_quality",
                       type: "grade",
                     },
                     {
                       key: 2,
                       label: "Filter by Burst Factor",
                       value: "burst_factor",
                       type: "inputSelect",
                     },
                     {
                       key: 3,
                       label: "Filter by Reel OD",
                       value: "reel_od",
                       type: "inputSelect",
                       unitType:"length"
                     },
                     {
                       key: 4,
                       label: "Filter by Core ID",
                       value: "core_id",
                       type: "inputSelect",
                       unitType:"length"
                     },
                     {
                       key: 5,
                       label: "Filter by Delivery Date",
                       value: "delivery_date",
                       type: "date",
                     },
                     {
                      key: 6,
                      label: "Filter by Machine Type",
                      value: "machine_type",
                      type: "machineType",
                    },
                    {
                      key: 7,
                      label: "Filter by Item Type",
                      value: "item_type",
                      type: "multiSelect",
                    },
                   ]}
                   selectedReelType = {selectedReelType}
                   applyFilter={applyfilter}
                   onReelTypeChange = {onReelTypeChange}
                 />
                 {filterTags.map((filter) => (
                   // <Tooltip
                   //   placement="bottomRight"
                   //   title={filter.tooltip || ""}
                   //   className="edit-tooltip"
                   //   getPopupContainer={(triggerNode) => triggerNode}
                   // >
                   <span className="filter-tags">
                     <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                     &nbsp;
                     <span>{filter.formattedType}</span>
                     &nbsp;
                     <span>{filter.operand}</span>
                     &nbsp;
                     <span>{filter.value}</span>
                     <span>
                       {" "}
                       <button
                         onClick={() => {
                           removeFilter(filter);
                         }}
                       >
                         {" "}
                         <Iconmoon
                           icon="wrong"
                           size={15}
                           color="#a8a8a8"
                         />{" "}
                       </button>
                     </span>
                     <Styled></Styled>
                   </span>
                   // </Tooltip>
                 ))} 
                  </>
                  {todaysRecordLoading ? (
                    <TableShimmer
                      header={todaysColumnsHead.current}
                      scroll={2500}
                    />
                  ) : todaysRecord?.length ? (
                    <Table
                      columns={todaysColumnsHead.current}
                      dataSource={todaysRecord}
                      onChange={onTodayChange}
                      pagination={{
                        current: currentPage,
                        total: totalTodaysRecord,
                        showTitle: false,
                        pageSize: paginationRefForAllTableParams.current.size,
                        showTotal: (total, range) =>
                          `Showing ${range[0]}-${range[1]} of ${total} results`,
                        // pageSizeOptions: [10, 20, 50, 100],
                        //showSizeChanger: true,
                      }}
                      scroll={{ x: 2600 }}
                      rowClassName={(record) =>
                        record.type === "Order" && record.priority && "true"
                      }
                    />
                  ) : (
                    <EmptyState
                      img={
                        emptyStateLabel === "noData" ||
                        emptyStateLabel === "filter"
                          ? emptyState_NoData
                          : emptyStateLabel === "search"
                          ? emptyState_Search
                          : emptyState_ConnectionAPIError
                      }
                      heading={emptyStatePropsData.heading}
                      subHeading={emptyStatePropsData.subHeading}
                      label={emptyStatePropsData.label}
                      refresh={refresh}
                    />
                  )}
                </Panes>
                <Panes tab="Yesterday's Records" key="2">
                <>
                   <SearchContainer
                   placeholder={"Search Order No, Stock or PO No."}
                   fetchOrder={searchOrders}
                   exportRole={yesterdaysRecord?.length ? true : false}
                   exportTrigger={exportHandler}
                   clearSearch={clearSearch}
                   setClearSearch={setClearSearch}
                   paginationParams={tableParams}
                   searchedValue={searchValue}
                   filterOptions={[
                     
                     {
                       key: 0,
                       label: "Filter by GSM",
                       value: "gsm",
                       type: "inputSelect",
                     },
                     {
                       key: 1,
                       label: "Filter by Grade/Quality",
                       value: "grade_quality",
                       type: "grade",
                     },
                     {
                       key: 2,
                       label: "Filter by Burst Factor",
                       value: "burst_factor",
                       type: "inputSelect",
                     },
                     {
                       key: 3,
                       label: "Filter by Reel OD",
                       value: "reel_od",
                       type: "inputSelect",
                       unitType:"length"
                     },
                     {
                       key: 4,
                       label: "Filter by Core ID",
                       value: "core_id",
                       type: "inputSelect",
                       unitType:"length"
                     },
                     {
                       key: 5,
                       label: "Filter by Delivery Date",
                       value: "delivery_date",
                       type: "date",
                     },
                     {
                      key: 6,
                      label: "Filter by Machine Type",
                      value: "machine_type",
                      type: "machineType",
                    },
                    {
                      key: 7,
                      label: "Filter by Item Type",
                      value: "item_type",
                      type: "multiSelect",
                    },
                   ]}
                   selectedReelType = {selectedReelType}
                   applyFilter={applyfilter}
                   onReelTypeChange = {onReelTypeChange}
                 />
                 {filterTags.map((filter) => (
                   // <Tooltip
                   //   placement="bottomRight"
                   //   title={filter.tooltip || ""}
                   //   className="edit-tooltip"
                   //   getPopupContainer={(triggerNode) => triggerNode}
                   // >
                   <span className="filter-tags">
                     <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                     &nbsp;
                     <span>{filter.formattedType}</span>
                     &nbsp;
                     <span>{filter.operand}</span>
                     &nbsp;
                     <span>{filter.value}</span>
                     <span>
                       {" "}
                       <button
                         onClick={() => {
                           removeFilter(filter);
                         }}
                       >
                         {" "}
                         <Iconmoon
                           icon="wrong"
                           size={15}
                           color="#a8a8a8"
                         />{" "}
                       </button>
                     </span>
                     <Styled></Styled>
                   </span>
                   // </Tooltip>
                 ))} 
                 </>
                  {yesterdaysRecordLoading ? (
                    <TableShimmer
                      header={yesterdaysColumnsHead.current}
                      scroll={2600}
                    />
                  ) : yesterdaysRecord?.length ? (
                    <Table
                      columns={yesterdaysColumnsHead.current}
                      dataSource={yesterdaysRecord}
                      onChange={onYestChange}
                      pagination={{
                        current: currentPage,
                        total: totalYesterdaysRecord,
                        showTitle: false,
                        pageSize: paginationRefForAllTableParams.current.size,
                        showTotal: (total, range) =>
                          `Showing ${range[0]}-${range[1]} of ${total} results`,
                        // pageSizeOptions: [10, 20, 50, 100],
                        //showSizeChanger: true,
                      }}
                      scroll={{ x: 2600 }}
                      rowClassName={(record) =>
                        record.type === "Order" && record.priority && "true"
                      }
                    />
                  ) : (
                    <EmptyState
                      img={
                        emptyStateLabel === "noData" ||
                        emptyStateLabel === "filter"
                          ? emptyState_NoData
                          : emptyStateLabel === "search"
                          ? emptyState_Search
                          : emptyState_ConnectionAPIError
                      }
                      heading={emptyStatePropsData.heading}
                      subHeading={emptyStatePropsData.subHeading}
                      label={emptyStatePropsData.label}
                      refresh={refresh}
                    />
                  )}
                </Panes>
                <Panes tab="All Records" key="3">
                <>
                   <SearchContainer
                   placeholder={"Search Order No, Stock or PO No."}
                   fetchOrder={searchOrders}
                   exportRole={allRecord?.length ? true : false}
                   exportTrigger={exportHandler}
                   clearSearch={clearSearch}
                   setClearSearch={setClearSearch}
                   paginationParams={tableParams}
                   searchedValue={searchValue}
                   filterOptions={[
                     {
                       key: 0,
                       label: "Filter by GSM",
                       value: "gsm",
                       type: "inputSelect",
                     },
                     {
                       key: 1,
                       label: "Filter by Grade/Quality",
                       value: "grade_quality",
                       type: "grade",
                     },
                     {
                       key: 2,
                       label: "Filter by Burst Factor",
                       value: "burst_factor",
                       type: "inputSelect",
                     },
                     {
                       key: 3,
                       label: "Filter by Reel OD",
                       value: "reel_od",
                       type: "inputSelect",
                       unitType:"length"
                     },
                     {
                       key: 4,
                       label: "Filter by Core ID",
                       value: "core_id",
                       type: "inputSelect",
                       unitType:"length"
                     },
                     {
                       key: 5,
                       label: "Filter by Delivery Date",
                       value: "delivery_date",
                       type: "date",
                     },
                     {
                      key: 6,
                      label: "Filter by Machine Type",
                      value: "machine_type",
                      type: "machineType",
                    },
                    {
                      key: 7,
                      label: "Filter by Item Type",
                      value: "item_type",
                      type: "multiSelect",
                    },
                   ]}
                   selectedReelType = {selectedReelType}
                   applyFilter={applyfilter}
                   onReelTypeChange = {onReelTypeChange}
                 />
                 {filterTags.map((filter) => (
                   // <Tooltip
                   //   placement="bottomRight"
                   //   title={filter.tooltip || ""}
                   //   className="edit-tooltip"
                   //   getPopupContainer={(triggerNode) => triggerNode}
                   // >
                   <span className="filter-tags">
                     <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                     &nbsp;
                     <span>{filter.formattedType}</span>
                     &nbsp;
                     <span>{filter.operand}</span>
                     &nbsp;
                     <span>{filter.value}</span>
                     <span>
                       {" "}
                       <button
                         onClick={() => {
                           removeFilter(filter);
                         }}
                       >
                         {" "}
                         <Iconmoon
                           icon="wrong"
                           size={15}
                           color="#a8a8a8"
                         />{" "}
                       </button>
                     </span>
                     <Styled></Styled>
                   </span>
                   // </Tooltip>
                 ))} 
                 </>
                  {allRecordLoading ? (
                    <TableShimmer
                      header={allRecordsColumnsHead.current}
                      scroll={2500}
                    />
                  ) : allRecord?.length ? (
                    <Table
                      columns={allRecordsColumnsHead.current}
                      dataSource={allRecord}
                      onChange={onChange}
                      pagination={{
                        current: currentPage,
                        total: totalAllRecord,
                        showTitle: false,
                        pageSize: paginationRefForAllTableParams.current.size,
                        showTotal: (total, range) =>
                          `Showing ${range[0]}-${range[1]} of ${total} results`,
                        // pageSizeOptions: [10, 20, 50, 100],
                        //showSizeChanger: true,
                      }}
                      scroll={{ x: 2600 }}
                      rowClassName={(record) =>
                        record.type === "Order" && record.priority && "true"
                      }
                    />
                  ) : (
                    <EmptyState
                      img={
                        emptyStateLabel === "noData" ||
                        emptyStateLabel === "filter"
                          ? emptyState_NoData
                          : emptyStateLabel === "search"
                          ? emptyState_Search
                          : emptyState_ConnectionAPIError
                      }
                      heading={emptyStatePropsData.heading}
                      subHeading={emptyStatePropsData.subHeading}
                      label={emptyStatePropsData.label}
                      refresh={refresh}
                    />
                  )}
                </Panes>
              </Tabs>
            </StyledTab>
          </div>
        </TableLayoutData>
        {orderSideDrawer && (
          <OrderAndStockDetails
            visible={orderSideDrawer}
            id={currentOrderId}
            onCloseOrderDrawer={closeOrderDrawer}
            type={recordType}
            orderType={orderType}
            jobcardType={jobcardType}
          />
        )}
        {parentSideDrawer && (
          <MultiStageParentSetDrawer
            parentReelId={selectedParentReel}
            visible={parentSideDrawer}
            onClose={closeComboDetailsDrawer}
            isProduced={isProduced}
            tabNo={currentTab}
            jobcardType={jobcardType}
            type={recordType}
          />
        )}
      </RightLayoutContainer>
    );
};
export default ProductionDetails;